import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const GetKpiFilesTreeRequest = (userId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}DriveTestUpload/GetMapKpiFilePaths`,
	params: { userId }
});

export const SyncFtpTreeRequest = (userId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}DriveTestUpload/SyncFtpTree`,
	params: { userId }
});

export const GetKpiProcessTableRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}DriveTestUpload/GetKpiProcessTable`,
	params: {}
});

export const GetTreeLastUpdateRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}DriveTestUpload/GetTreeLastUpdate`,
	params: {}
});

export const RunKpiFilesParserRequest = (userId, selectedFiles) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}DriveTestUpload/RunMapKpiFilesParser`,
	data: { userId, selectedFiles }
});

export const SearchFTPDirectoryRequest = (userId, searchPath) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}DriveTestUpload/GetTreeFromFTPDirectory`,
	params: { userId, searchPath }
});
